import { render, staticRenderFns } from "./multipleNewSelect.vue?vue&type=template&id=fdb872e0&scoped=true&"
import script from "./multipleNewSelect.vue?vue&type=script&lang=js&"
export * from "./multipleNewSelect.vue?vue&type=script&lang=js&"
import style0 from "./multipleNewSelect.vue?vue&type=style&index=0&id=fdb872e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb872e0",
  null
  
)

export default component.exports